import axios from "axios";
import runtimeConfig from "@/common/runtime-config";

axios.interceptors.request.use(
  (config) => {
    config.params = { ...config.params };
    refreshAuthorizationHeader();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export function configAxios() {
  axios.defaults.baseURL = runtimeConfig.apiBaseUrl;
}

function configApi(baseURL) {
  const requestBase = axios.create({ baseURL });
  const token = localStorage.getItem("token");

  requestBase.defaults.headers.common["Authorization"] = "Bearer " + token;

  return requestBase;
}
export const adminApi = configApi(runtimeConfig.apiAdminBaseUrl);
export const authApi = configApi(runtimeConfig.oidc.authority);

export default async function refreshAuthorizationHeader() {
  const token = localStorage.getItem("token");
  if (token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
}

refreshAuthorizationHeader();
